import { createRouter, createWebHashHistory } from 'vue-router';
import { loadI18n } from '@/infrastructure/locales';
import { NAV_MENU_TYPE } from '@eureka/shared/nav-bar';
import { isUserLogin } from '@eureka/utils/account';

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      beforeEnter: async (to, from, next) => {
        await loadI18n();
        const { search, hash } = window.location;
        // normalizing url for query appearing before #
        if (search) {
          let newHash = hash || '#/home';
          // If hash already has query, merge them
          if (newHash.includes('?')) {
            newHash += '&' + search.slice(1); // remove leading "?"
          } else {
            newHash += search;
          }
          // window.location.replace(`/${newHash}`);
          window.location.href = window.location.origin + `/mse/${newHash}`;
          return; // ⛔ stop navigation
        }

        next();
      },
      children: [
        {
          name: 'AgentEntryPage',
          path: '/agent/:productPath',
          component: () => import('@/components/agent-entry/TheAgentEntryPage.vue'),
        },
        // {
        //   name: 'MaterialSearchEntryPage',
        //   path: '/material-search',
        //   redirect: '/material-search/general',
        //   component: () => import('@/components/material-search/MaterialSearch.vue'),
        //   children: [
        //     {
        //       name: 'MaterialSearchMainPage',
        //       path: ':tab',
        //       component: () => import('@/components/material-search/MaterialSearch.vue'),
        //     },
        //   ],
        // },
        {
          name: 'FormulationEntryPage',
          path: '/agent/formulation',
          component: () => import('@/components/formulation/agent-entry/FormulationEntryPage.vue'),
        },
        {
          name: 'MSEDocAnalyzerResult',
          path: '/material/analyzer/:lsAgentId',
          component: () => import('@/components/pages/doc-analyzer/MSEDocAnalyzer.vue'),
        },
        {
          name: 'ReverseEngineering',
          path: '/reverse-engineering',
          children: [
            {
              name: 'ReverseEngineeringConversation',
              path: ':conversation_id',
              component: () =>
                import('@/components/pages/reverse-engineering/ConversationPage.vue'),
            },
            {
              name: 'ReverseEngineeringSharedConversation',
              path: 'shared/:conversation_id',
              component: () =>
                import('@/components/pages/reverse-engineering/ConversationPage.vue'),
            },
          ],
        },
        {
          name: 'Formulation',
          path: '/formulation',
          children: [
            {
              name: 'FormulationConversation',
              path: ':session_id',
              component: () => import('@/components/pages/formulation/ConversationPage.vue'),
            },
          ],
        },
        {
          name: 'Guest',
          path: '/shared',
          children: [
            {
              name: 'GuestFormulationConversation',
              path: 'formulation/:session_id',
              component: () => import('@/components/pages/formulation/ConversationPage.vue'),
              props: () => ({
                guest: true,
              }),
            },
          ],
        },
        {
          name: 'CommunityGallery',
          path: '/gallery',
          component: () => import('@/components/pages/community/CommunityGalleryPage.vue'),
          meta: {
            navModuleType: NAV_MENU_TYPE.COMMUNITY,
          },
        },
        {
          name: 'SubscriptionLinkPage',
          path: '/subscribe',
          component: () => import('@/components/pages/subscription/SubscriptionLinkPage.vue'),
        },
        {
          name: 'LegacyMseSearchPage',
          path: '/material-search/general',
          redirect: '/material-search'
          // Required to redirect from super agent home page 
        },
        {
          name: 'MseSearchPage',
          path: '/material-search',
          component: () => import('@/components/pages/search-query-builder/SearchEntryPage.vue'),
          children: [
            {
              name: 'MseSearchResultPage',
              path: ':source/:qid',
              component: () =>
                import('@/components/pages/search-query-builder/SearchEntryPage.vue'),
            },
          ],
        },
        {
          path: '/:pathMatch(.*)*',
          redirect: '',
        },
      ],
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  if (import.meta.env.dev) {
    next();
  }

  const isLogin = await isUserLogin();
  if (to.path === '/home' || to.fullPath === '/') {
    if (isLogin) {
      window.location.href = window.location.origin + '/home';
    } else {
      window.location.href = window.location.origin + '/mse-landing';
    }
  }

  console.log('Global Route Guard:', {
    step: 'beforeEach',
    to: {
      path: to.path,
      name: to.name,
      params: to.params,
      meta: to.meta,
    },
    from: {
      path: from.path,
      name: from.name,
    },
    matched: to.matched.map((record) => ({
      path: record.path,
      name: record.name,
    })),
  });
  next();
});

export { router };
export default router;
